module.exports = __webpack_public_path__ + "static/media/laptop.e36790d5.jpg";